import { createIcon } from './createIcon';

/** Credentials — a key, for the venue API keys the proxy holds on the user's behalf. */
export const CredentialsIcon = createIcon({
  name: 'CredentialsIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <circle cx="6" cy="6" r="3.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8.4 8.4 13.25 13.25M10.5 10.5l-1.4 1.4M12 12l-1.4 1.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
});

export default CredentialsIcon;
